<script setup>
  import { useI18n } from 'vue-i18n';
  import Icon from '@/components/icons/Icon.vue';

  const { t } = useI18n();

  const model = defineModel({ type: Array });

  defineProps({
    models: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  });
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <p v-if="loading" class="jwx-modal__section-description">{{ t('windAlerts.loadingModels') }}</p>
      <p v-else-if="models.length === 0" class="jwx-modal__section-description">{{ t('windAlerts.noModelsAvailable') }}</p>
      <ul v-else class="jwx-block jwx-table-view" data-surface="1">
        <li v-for="forecastModel in models" :key="forecastModel.model_id" class="jwx-table-view__row">
          <div class="jwx-table-view__row-content">
            <label :for="'model-' + forecastModel.model_id" class="jwx-table-view__row-label">
              {{ forecastModel.model_short_name }}
              <Icon v-if="forecastModel.upgrade_available" name="lock" />
              <Icon v-else-if="forecastModel.is_premium" name="premium-badge" />
            </label>
            <div class="jwx-table-view__row-actions">
              <div class="jwx-radio-control">
                <input
                  type="checkbox"
                  name="forecast-model"
                  :id="'model-' + forecastModel.model_id"
                  :value="forecastModel.model_id"
                  v-model="model"
                  class="jwx-radio-control__input jwx-hidden-control"
                />
                <label :for="'model-' + forecastModel.model_id" class="jwx-radio-control__label">
                  <p class="sr-only">{{ t('windAlerts.srSelectModel', { model: forecastModel.model_short_name }) }}</p>
                  <span class="jwx-radio-control__selection-indicator">
                    <Icon v-if="model.includes(forecastModel.model_id)" name="checkmark" class="jwx-radio-control__indicator-icon" />
                  </span>
                </label>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
